<template>
  <popup-block
    :closeModal="closeModal"
    :shown="opened"
    @submit="saveModal"
    @close="closeModal">
    <template v-if="local_obj" v-slot:popup_title>
      Title
    </template>
    <template v-if="local_obj" v-slot:popup_sub_title>
      Sub Title
    </template>

    <template v-if="local_obj" v-slot:default>

    </template>

    <div slot="popup_footer">
      <div class="d-flex justify-content-between">
        <button
          class="dark_button"
          type="submit">
          Save
        </button>
        <button class="dark_button" @click="closeModal">Close</button>
      </div>
    </div>
  </popup-block>
</template>

<script>
import PopupBlock from "./PopupBlock";
import {UNLINK_VARIABLE} from "../../helpers/variable_helpers";

export default {
  name: 'ExamplePopup',
  components: {
    PopupBlock,
  },
  computed: {
  },
  data() {
    return {
      opened: false,
      local_obj: null,
    }
  },
  methods: {
    openModal(data) {
      this.opened = true
      this.$set(this, 'local_obj', UNLINK_VARIABLE(data))
    },
    closeModal() {
      this.opened = false
      this.clearModalData()
      this.$emit('closed', true)
    },
    clearModalData() {
      this.local_obj = null
    },
    saveModal(close = true) {
    },
  },
}
</script>
